// extracted by mini-css-extract-plugin
module.exports = {"container":"Navigation_container__34JUv"};